var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid grid__container",style:({ width: _vm.cw + 'px' })},[_vm._t("default",[_vm._v("grid")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }